import {Component} from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-purchase-order-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.sass'
})
export class PurchaseOrderHomeComponent {
  constructor(
    private _snackBar: MatSnackBar,
  ) {
  }
}
